import React from "react"

import { useHistory } from "react-router-dom"

import { Box, Button, Flex, List, ListItem, PseudoBox } from "@chakra-ui/core"

import ordered from "src/ordered"

const StudyGroupRow = ({ studyGroup }) => {
  const history = useHistory()
  return (
    <PseudoBox
      as="tr"
      key={studyGroup.id}
      borderBottom="1px"
      borderBottomColor="gray.400"
      _last={{ border: "none" }}
    >
      <td>
        <Flex align="center" direction="row">
          <Box my="2" flexBasis="25%">
            {studyGroup.name}
          </Box>
        </Flex>
      </td>
      <td>
        <Flex>
          <List>
            {ordered(studyGroup.students, "lastName").map(student => (
              <ListItem key={student.id}>{student.fullName}</ListItem>
            ))}
          </List>
        </Flex>
      </td>
      <td>
        <Flex align="center" direction="row">
          <Box flexBasis="25%">{studyGroup.tutor?.fullName}</Box>
          {studyGroup.tutor && (
            <Button
              variant="outline"
              variantColor="red"
              ml="4"
              size="sm"
              onClick={() => history.push("/messages")}
            >
              Message {studyGroup.tutor.firstName}
            </Button>
          )}
        </Flex>
      </td>
    </PseudoBox>
  )
}

export default StudyGroupRow
